export default "__VITE_ASSET__Dn4khgFk__"